import React from 'react';
import { BasketRoomExtra } from 'shared-types/Room';
import { RoomDetailsGrid } from './RoomDetails.styles';
import { RoomExtra } from './RoomExtra';

type RoomDetailsProps = {
  roomExtras: BasketRoomExtra[];
};

export const RoomDetails: React.FC<RoomDetailsProps> = ({ roomExtras }) => (
  <>
    <RoomDetailsGrid>
      {roomExtras.map((extra) => (
        <RoomExtra roomExtra={extra} />
      ))}
    </RoomDetailsGrid>
  </>
);
